import { Element } from '@xmpp/xml'
import { PayloadIn } from '../types'
import { getMessageStanzaData } from '../helpers'
import { INBOX_XMLNS } from '../constants'
import { getRoomAndUserId } from './getRoomAndUserId'

// Example of a status change stanza:
// <message
//   from='1e0ae1e2-add3-4438-b734-ba7173089477@localhost'
//   id='14fd98ee8a9e13f3'
//   to='1e0ae1e2-add3-4438-b734-ba7173089477@localhost'
//   xmlns='jabber:client'
// >
//  <x jid='2d491883-3310-4279-8df5-6c56fce61962@conference.localhost' queryid='14fd98ee8a9e13f3' xmlns='erlang-solutions.com:xmpp:inbox:0#conversation'>
//    <read>false</read>
//    <box>archive</box> when opening it's <box>inbox</box>
//    <archive>true</archive> when opening it's <archive>false</archive>
//    <mute>0</mute>
//  </x>
// </message>

export const parseConversationStatusChangeStanza = (
  stanza: Element
): Extract<PayloadIn, { type: 'StatusChange' }> | undefined => {
  const x = stanza?.getChild('x')
  const isInboxStanza = x?.getAttr('xmlns') === `${INBOX_XMLNS}#conversation`
  const { roomId } = getRoomAndUserId(x?.getAttr('jid'))
  const { id } = getMessageStanzaData(stanza)
  const status = x?.getChild('archive')?.getText()

  if (!roomId || !id || !status || !isInboxStanza) {
    return
  }

  return {
    type: 'StatusChange',
    roomId,
    id,
    author: 'bot',
    sent: true,
    status: status === 'true' ? 'CLOSED' : 'OPEN',
    statuses: {},
    timestamp: new Date().toISOString(),
  }
}
